var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 39,
    rx: 19.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 21C29.5523 21 30 20.5523 30 20C30 19.4477 29.5523 19 29 19L29 21ZM10.2929 19.2929C9.90237 19.6834 9.90237 20.3166 10.2929 20.7071L16.6569 27.0711C17.0474 27.4616 17.6805 27.4616 18.0711 27.0711C18.4616 26.6805 18.4616 26.0474 18.0711 25.6569L12.4142 20L18.0711 14.3431C18.4616 13.9526 18.4616 13.3195 18.0711 12.9289C17.6805 12.5384 17.0474 12.5384 16.6569 12.9289L10.2929 19.2929ZM29 19L11 19L11 21L29 21L29 19Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideArrow);
export default __webpack_public_path__ + "static/media/sideArrow.30d67c6b95008ab4d6b61f04ec43cdb5.svg";
export { ForwardRef as ReactComponent };